import { ThemeableStack, styled, GetProps, TamaguiElement, interaction } from '@mythical/ui'

import React, { forwardRef } from 'react'
import { IconProps } from '../Icon/IconProps'

export type ButtonProps = GetProps<typeof ButtonFrame> & {
  children?: React.ReactElement<IconProps>
}

export const ButtonFrame = styled(ThemeableStack, {
  name: 'Button',
  tag: 'button',
  focusable: true,
  hoverTheme: true,
  pressTheme: true,
  borderWidth: 1,
  borderColor: 'transparent',
  justifyContent: 'center',
  alignItems: 'center',
  flexWrap: 'nowrap',
  flexDirection: 'row',
  cursor: 'pointer',
  bg: 'transparent',

  pressStyle: {
    borderColor: 'transparent',
    bg: 'transparent',
    ...interaction.opacity.pressStyle,
  },

  hoverStyle: {
    borderColor: 'transparent',
    bg: 'transparent',
    ...interaction.opacity.hoverStyle,
  },

  focusStyle: {
    borderColor: 'transparent',
    bg: 'transparent',
    ...interaction.opacity.focusStyle,
  },

  variants: {
    active: {
      true: {
        hoverStyle: {
          backgroundColor: '$brandPurple',
        },
      },
    },
    size: {
      '...size': (size, { tokens }) => {
        return {
          width: tokens.size[size] ?? size,
          height: tokens.size[size] ?? size,
        }
      },
    },
    disabled: {
      true: {
        opacity: 0.375,
        pointerEvents: 'none',
      },
    },
  } as const,

  defaultVariants: {
    size: '$4',
  },
})

export const IconButton = ButtonFrame.extractable(
  forwardRef<TamaguiElement, ButtonProps>((props: ButtonProps, ref) => {
    const { children, ...rest } = props
    return (
      <ButtonFrame ref={ref} {...rest}>
        {children}
      </ButtonFrame>
    )
  }),
)
